<script setup>
import { onMounted, defineProps } from "vue";
import { ArrowRight } from "@element-plus/icons-vue";
import { useRouter } from "vue-router";
const router = useRouter();

const props = defineProps({
  imgUrl: {
    type: String,
    default: "@/assets/image/home/Face.png",
  },
  title: {
    type: String,
    default: "标题一",
  },
  subtitle: {
    type: String,
    default: "副标题",
  },
  goUrl: {
    type: String,
    default: "/",
  },
});
const goRouter = (url) => {
  router.push(url);
};

onMounted(() => {});
</script>

<template>
  <div data-aos="flip-left" data-aos-easing="ease-out-cubic" class="home_card">
    <div class="home_card_l">
      <img class="home_card_img" :src="imgUrl" alt="" />
    </div>
    <div class="home_card_r">
      <span class="home_card_r_title">{{ title }}</span>
      <span class="home_card_r_subtitle">{{ subtitle }}</span>
      <span class="home_card_r_more" @click="goRouter(goUrl)"
        >{{ $t('home.mcardBtn') }} <el-icon color="#016DFE" :size="14"><ArrowRight /></el-icon>
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.home_card {
  padding: 30px;
  display: flex;
  background-image: url('@/assets/image/home/card-bg.png');
  background-size: cover;
  border-radius: 20px;
  transition: all 1s ease-in-out;
  cursor: default;
  .home_card_l {
    margin-right: 30px;
    .home_card_img {
      width: 63px;
      height: 64px;
    }
  }
  .home_card_r {
    display: flex;
    flex-direction: column;
    .home_card_r_title {
      font-size: 20px;
      font-weight: bold;
      color: #000;
    }
    .home_card_r_subtitle {
      font-size: 16px;
      color: #000e18b2;
      padding: 10px 0 30px;
    }
    .home_card_r_more {
      width: fit-content;
      cursor: pointer;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #016dfe;
      transition: all 0.3s ease;
    }
    .home_card_r_more:hover {
      scale: calc(1.05);
    }
  }
}
.home_card:hover {
    opacity: 0.8;
}

@media (max-width: 768px) {
}
</style>
